import { post } from 'vio-libs';
export function postCustomerSpaceRequest(siteInformation, organization, emailAddress, rackVolume, powerNeeds, requirements) {
    return post(`customer-space-request?organization=${organization}`, {
        data: {
            email_address: emailAddress,
            power_needs: powerNeeds,
            rack_volume: rackVolume,
            requirements,
            site_information: siteInformation
        }
    });
}
